import { useEffect,useState } from 'react';
import '../styles/footer.css';


const Footer = () => {
  const [width,setWidth] = useState(window.innerWidth);

  useEffect(() => {
    
    window.addEventListener('resize',()=>{
      setWidth(window.innerWidth);
    });
    return ()=>{
      window.removeEventListener('resize',()=>{
        setWidth(window.innerWidth);
      });
    }
  },[]);

  return (
    <div className="footer-container">
      <footer className="text-center text-lg-start text-dark footer-container">
        {/* Footer Links */}
        <section style={{ padding: "20px 10px", backgroundColor: "#005D27" }} className="pb-5">
          <div id="footer-area" className="container text-start mt-5">
            <div className="row d-flex justify-content-between flex-wrap">
              
              {/* Company Info Section */}
              <div className="col-12 col-md-4 col-lg-5 col-xl-5 mb-4">
                <h6 className="text-uppercase fw-bold">Our Response Promise</h6>
                <hr className="mb-4 mt-0 d-inline-block mx-auto" style={{ width: "60px", color: "white", height: "2px" }} />
                <p className="footer-info">
                Our mission is to empower the next generation of mariners with cutting-edge knowledge, practical skills, and industry insights. With years of experience in the maritime sector, we've established ourselves as trusted partners for seafarer training and professional development.                </p>
              </div>

              {/* Quick Links Section */}
              <div className="col-6 col-md-3 col-lg-2 col-xl-2 mb-4">
                <h6 className="text-uppercase fw-bold">Browse Links</h6>
                <hr className="mb-4 mt-0 d-inline-block mx-auto" style={{ width: "60px", backgroundColor: "#7c4dff", height: "2px" }} />
                <p className="quick-links"><a href="/">Home</a></p>
                <p className="quick-links pt-2"><a href="#aboutus">About Us</a></p>
                <p className="quick-links pt-2"><a href="https://marinersmentor.onlinetestpanel.com/#home-slider">Exams</a></p>
                <p className="quick-links pt-2"><a href="/services">Services</a></p>
                <p className="quick-links pt-2"><a href="/courses">Courses</a></p>
              </div>

              {/* Services Section */}
              <div className="col-6 col-md-3 col-lg-2 col-xl-2 mb-4">
                <h6 className="text-uppercase fw-bold">Services</h6>
                <hr className="mb-4 mt-0 d-inline-block mx-auto" style={{ width: "60px", backgroundColor: "#7c4dff", height: "2px" }} />
                <p className="quick-links"><a href="/services">Documentary</a></p>
                <p className="quick-links pt-2"><a href="/services">Documentary Renewal</a></p>
                <p className="quick-links pt-2"><a href="/services">Miscellaneous</a></p>
              </div>

              {/* Social Media Section */}
              <div className="col-12 col-md-6 col-lg-2 col-xl-2 ">
                <h6 className="text-uppercase fw-bold">Follow Us</h6>
                <hr className="mb-4 mt-0 d-inline-block mx-auto" style={{ width: "60px", backgroundColor: "#7c4dff", height: "2px" }} />
                <p className="footer-info">
                #54, first floor, <br /> Beach road,<br/> Thoothukudi - 628001<br/>
                  Tamil Nadu
                  <br/>
                  <b>Land mark:</b> opposite to State Bank of India (SBI)
                      </p>
                  

                <div  className="d-flex gap-3 ">
                  <a href="tel:+918300159386" rel="noopener noreferrer">
                    <i className="bi bi-telephone" style={{ fontSize: "1.5rem", color: "#D6D6D6" }}></i>
                  </a>

                  <p className="quick-links pt-2"><a href="tel:+918300159386">+91 83001 59386</a></p>
                </div>
                <hr className="mb-4 mt-0 d-inline-block mx-auto" />
                <div className="d-flex flex-wrap justify-content-start gap-3 mb-4">
                  <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
                    <i className="bi bi-linkedin" style={{ fontSize: "1.5rem", color: "#D6D6D6" }}></i>
                  </a>
                  <a href="https://tinyurl.com/ykv32xcb" target="_blank" rel="noopener noreferrer">
                    <i className="bi bi-instagram" style={{ fontSize: "1.5rem", color: "#D6D6D6" }}></i>
                  </a>
                  <a href="https://tinyurl.com/3bte9mvs" target="_blank" rel="noopener noreferrer">
                    <i className="bi bi-youtube" style={{ fontSize: "1.5rem", color: "#D6D6D6" }}></i>
                  </a>
                  <a href="https://tinyurl.com/2szzrt5a" target="_blank" rel="noopener noreferrer">
                    <i className="bi bi-facebook" style={{ fontSize: "1.5rem", color: "#D6D6D6" }}></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Footer Copyright Section */}
        <div className="text-center p-3" style={{ backgroundColor: "#005D27", borderTop: "1px solid white", color: "white", fontSize: "15px" }}>
          © 2025 Copyright -
          <a className="text-white" href="https://mdbootstrap.com/"> Mariners Mentor</a>  {`  `}
        {width<500 ? <br/> : '|' } Developed by <a className="text-white" href="https://dcubix.com/" target='_blank' rel="noreferrer"> Dcubix Technologies</a>

        </div>
      </footer>
    </div>
  );
};

export default Footer;
